import React, { useEffect, useState } from 'react';
import { useParams, useLocation  } from 'react-router-dom';
import LayoutWithNavbar from './LayoutWithNavbar';
import { fetchVendorMismatchDetails, updateForm2BInvoice, fetchInvoiceForm2BDetails } from '../services/api';
import * as XLSX from 'xlsx';

const VendorMismatchDetailPage = () => {
  const { gstid } = useParams();
  const [rows, setRows] = useState([]);
  const [editModal, setEditModal] = useState({ open: false, id: null, value: '', reference: '' });
  const [viewModal, setViewModal] = useState({ open: false, data: null });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const stateId = searchParams.get('state');

  const loadData = async () => {
    const res = await fetchVendorMismatchDetails({ gstid, state: stateId });
    if (res.success) setRows(res.data.mismatched_invoices || []);
  };

  useEffect(() => {
    loadData();
  }, [gstid]);

  const openEditModal = (id, currentValue, invoiceTableValue) => {
    setEditModal({ open: true, id, value: currentValue, reference: invoiceTableValue });
  };

  const handleEditSubmit = async () => {

    const res = await updateForm2BInvoice(editModal.id, { form2b_invoice: editModal.value });
    if (res.success) {
      alert('Updated successfully');
      setEditModal({ open: false, id: null, value: '', reference: '' });
      loadData();
    } else {
      alert('Update failed');
    }
  };


  const handleMatchInvoice = async () => {
    const { form2b_entry, invoice } = viewModal.data || {};
    const res = await updateForm2BInvoice(form2b_entry?.id, { form2b_invoice: invoice?.ref_no });
  
    if (res.success) {
      alert('Form2B invoice number updated successfully!');
      setViewModal({ open: false, data: null });
      loadData();
    } else {
      alert(res.message || 'Update failed.');
    }
  };
  

  const openViewModal = async (entryId, invid) => {
    const res = await fetchInvoiceForm2BDetails(entryId, invid);
    if (res.form2b_entry && res.invoice) {
      setViewModal({ open: true, data: res });
    } else {
      alert("Failed to fetch details.");
    }
  };

  const capitalizeKey = (key) => {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleExport = () => {
    if (rows.length === 0) {
      alert("No data to export.");
      return;
    }

    const sheetData = rows.map(row => ({
      'Vendor Name': row.vendor_name,
      'GST No': row.gst_no,
      'Form2B Invoice': row.form2b_invoice,
      'Invoice Table': row.invoice_table_invoice,
      'Date': row.invoice_date,
      'Invoice Value': row.invoice_value,
      'Form2B Value': row.form2b_total_value,
      'Form2B Tax': row.form2b_tax,
      'Invoice Tax': row.invoice_tax
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendor Mismatches');
    XLSX.writeFile(workbook, `Vendor_Mismatch_${gstid}.xlsx`);
  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <div style={styles.headerSection}>
          <h2 style={styles.heading}>Vedor Wise ITC Mismatch Details</h2>
          <button onClick={handleExport} style={styles.exportButton}>Export</button>
        </div>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                {['Vendor Name', 'GST No', 'Form2B Invoice', 'Invoice Table', 'Date', 'Value', 'Form2B Value', 'Form2B Tax', 'Invoice Tax', 'Action'].map((col, i) => (
                  <th key={i} style={styles.th}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} style={styles.tr}>
                  <td style={styles.td}>{row.vendor_name}</td>
                  <td style={styles.td}>{row.gst_no}</td>
                  <td style={styles.td}>{row.form2b_invoice}</td>
                  <td style={styles.td}>{row.invoice_table_invoice}</td>
                  <td style={styles.td}>{row.invoice_date}</td>
                  <td style={styles.td}>{row.invoice_value}</td>
                  <td style={styles.td}>{row.form2b_total_value}</td>
                  <td style={styles.td}>{row.form2b_tax}</td>
                  <td style={styles.td}>{row.invoice_tax}</td>
                  <td style={styles.td}>
                    <button onClick={() => openEditModal(row.id, row.form2b_invoice, row.invoice_table_invoice)} style={styles.editButton}>Edit</button>
                    <button onClick={() => openViewModal(row.id, row.invid)} style={styles.viewButton}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {editModal.open && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <h4>Edit Form2B Invoice</h4>
              <input
                type="text"
                value={editModal.value}
                onChange={e => setEditModal({ ...editModal, value: e.target.value })}
                style={styles.modalInput}
              />
              <div style={styles.modalActions}>
                <button onClick={handleEditSubmit} style={styles.searchButton}>Submit</button>
                <button onClick={() => setEditModal({ open: false, id: null, value: '', reference: '' })} style={styles.cancelButton}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        {viewModal.open && viewModal.data && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <h3 style={styles.modalTitle}>Form2B vs Invoice Comparison</h3>
              <div style={styles.modalTableWrapper}>
                <div style={styles.tableBlock}>
                  <h4 style={styles.subHeading}>Form2B Details</h4>
                  <table style={styles.compareTable}>
                    <tbody>
                    {Object.entries(viewModal.data.form2b_entry)
                        .filter(([key]) => key !== 'id')
                        .map(([key, value]) => (
                          <tr key={key}>
                            <td style={styles.compareTh}>{capitalizeKey(key)}</td>
                            <td style={{ ...styles.compareTd, backgroundColor: key === 'invoice_number' ? '#ffcccc' : styles.compareTd.backgroundColor }}>
                              {value}
                            </td>
                          </tr>
                      ))}

                    </tbody>
                  </table>
                </div>

                <div style={styles.tableBlock}>
                  <h4 style={styles.subHeading}>Invoice Details</h4>
                  <table style={styles.compareTable}>
                    <tbody>
                    {Object.entries(viewModal.data.invoice)
                        .filter(([key]) => key !== 'id')
                        .map(([key, value]) => (
                          <tr key={key}>
                            <td style={styles.compareTh}>{capitalizeKey(key)}</td>
                            <td style={{ ...styles.compareTd, backgroundColor: key === 'ref_no' ? '#ffcccc' : styles.compareTd.backgroundColor }}>
                              {value}
                            </td>
                          </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </div>

              <div style={styles.modalActions}>
                
              <button onClick={handleMatchInvoice} style={styles.matchButton}>
                Match Invoice
              </button>




                <button
                  onClick={() => setViewModal({ open: false, data: null })}
                  style={styles.cancelButton}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: { padding: '30px', backgroundColor: '#f8f9fa', minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif' },
  headerSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  heading: { fontSize: '24px', fontWeight: '600' },
  exportButton: { padding: '10px 20px', fontSize: '16px', fontWeight: '600', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  tableWrapper: { overflowX: 'auto', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 0 10px rgba(0,0,0,0.04)' },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: '900px' },
  th: { padding: '12px', backgroundColor: '#343a40', color: '#fff', fontWeight: '500', textAlign: 'left', borderBottom: '1px solid #dee2e6' },
  tr: { transition: 'background-color 0.2s' },
  td: { padding: '12px', borderBottom: '1px solid #dee2e6', fontSize: '16px', backgroundColor: '#fff' },
  editButton: { padding: '6px 12px', backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  viewButton: { padding: '6px 12px', backgroundColor: '#17a2b8', color: '#fff', fontWeight: 'bold', border: 'none', borderRadius: '4px', cursor: 'pointer', marginLeft: '8px' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 },
  modalContent: { backgroundColor: '#fff', padding: '30px', borderRadius: '10px', width: '90%', maxWidth: '1000px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 0 12px rgba(0,0,0,0.2)' },
  modalTitle: { fontSize: '22px', fontWeight: '600', marginBottom: '20px', textAlign: 'center', color: '#333' },
  modalTableWrapper: { display: 'flex', gap: '30px', justifyContent: 'space-between', flexWrap: 'wrap' },
  tableBlock: { flex: 1, minWidth: '240px' },
  subHeading: { fontSize: '18px', fontWeight: '600', marginBottom: '10px', color: '#007bff' },
  compareTable: { width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' },
  compareTh: { padding: '8px 12px', backgroundColor: '#f1f1f1', fontWeight: '600', borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc', textTransform: 'capitalize', width: '50%' },
  compareTd: { padding: '8px 12px', backgroundColor: '#fff', borderBottom: '1px solid #ccc' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', marginTop: '20px' },
  searchButton: { padding: '12px 24px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  cancelButton: { padding: '12px 24px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  modalInput: { width: '100%', padding: '12px', fontSize: '16px', borderRadius: '6px', border: '1px solid #ccc', marginTop: '12px' },
  matchButton: {padding: '12px 24px',backgroundColor: '#28a745',color: '#fff',border: 'none',borderRadius: '6px',cursor: 'pointer',fontWeight: '600',fontSize: '16px',marginRight: '12px'}
  
};

export default VendorMismatchDetailPage;
